$(document).ready(function () {

    $("#accessories_modal").submit(function (e) {

        e.preventDefault();
        console.log($(this)[0].attributes['action']);
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').empty();

        var firstname = $('#accessoriesFirstname').val();
        console.log(firstname);
        var errors = 0;
        $('.accessoriesFirstname .invalid-feedback').empty();
        if (!firstname) {
            $('#accessoriesFirstname').addClass('is-invalid');
            $('#accessoriesFirstname').css('border-color', '#dc3545');
            $('.accessoriesFirstname').siblings('invalid-feedback').prevObject.html('To pole jest wymagane');
        } else {
            if (firstname.length < 3) {
                $('#accessoriesFirstname').addClass('is-invalid');
                $('#accessoriesFirstname').css('border-color', '#dc3545');
                var errors = 1;
                $('.accessoriesFirstname').siblings('invalid-feedback').prevObject.html('Imię musi zawierać minimum trzy litery.');
            } else {
                $('#accessoriesFirstname').css('border-color', '#D9D9D9');
            }


        }

        var lastname = $('#accessoriesLastname').val();
        $('.accessoriesLastname .invalid-feedback').empty();
        if (!lastname) {
            $('#accessoriesLastname').addClass('is-invalid');

            $('#accessoriesLastname').css('border-color', '#dc3545');
            var errors = 1;
            $('.accessoriesLastname').siblings('invalid-feedback').prevObject.html('To pole jest wymagane');
        } else {
            if (lastname.length < 3) {
                $('#accessoriesLastname').addClass('is-invalid');

                $('#accessoriesLastname').css('border-color', '#dc3545');
                var errors = 1;
                $('.accessoriesLastname').siblings('invalid-feedback').prevObject.html('Nazwisko musi zawierać minimum trzy litery.');
            } else {
                $('#accessoriesLastname').css('border-color', '#D9D9D9');
            }
        }


        var email = $('#accessoriesEmail').val();
        if (!email) {
            $('#accessoriesEmail').addClass('is-invalid');

            $('#accessoriesEmail').css('border-color', '#dc3545');
            $('.accessoriesEmail').siblings('invalid-feedback').prevObject.html('To pole jest wymagane');
            var errors = 1;
        } else {
            if (IsEmail(email)) {
                $('#accessoriesEmail').css('border-color', '#D9D9D9');
            } else {
                $('#accessoriesEmail').addClass('is-invalid');

                $('#accessoriesEmail').css('border-color', '#dc3545');
                $('.accessoriesEmail').siblings('invalid-feedback').prevObject.html('Wpisz poprawny adres e-mail');
                var errors = 1;
            }
        }

        var phoneInput = $('#accessoriesPhone');
        var phone = phoneInput.val();
        if (phone) {
            if (phone.length < 7) {
                $('#accessoriesPhone').addClass('is-invalid');

                $('#accessoriesPhone').css('border-color', '#dc3545');
                $('.accessoriesPhone').siblings('invalid-feedback').prevObject.html('Podany numer telefonu jest za krótki');
                var errors = 1;
            } else {
                if (!validatePhone(phone)) {
                    $('#accessoriesPhone').addClass('is-invalid');

                    $('#accessoriesPostalCode').css('border-color', '#dc3545');
                    $('.accessoriesPhone').siblings('invalid-feedback').prevObject.html('Wpisz poprawny 9-cyfrowy numer telefonu');
                    var errors = 1;
                } else {
                    $('#accessoriesPhone').css('border-color', '#D9D9D9');
                }
            }
        }

        var postalCodeInput = $('#accessoriesPostalCode');
        var postalCode = postalCodeInput.val();
        if (postalCode) {
            if (postalCode.length < 6) {
                $('#accessoriesPostalCode').addClass('is-invalid');
                $('#accessoriesPostalCode').css('border-color', '#dc3545');
                $('.accessoriesPostalCode').siblings('invalid-feedback').prevObject.html('Podany kod pocztowy jest za krótki');
                var errors = 1;
            } else {
                if (!validatePostalCode(postalCode)) {
                    $('#accessoriesPostalCode').addClass('is-invalid');
                    $('#accessoriesPostalCode').css('border-color', '#dc3545');
                    $('.accessoriesPostalCode').siblings('invalid-feedback').prevObject.html('Wpisz poprawny kod pocztowy');
                    var errors = 1;
                } else {
                    $('#accessoriesPostalCode').css('border-color', '#D9D9D9');
                }
            }
        }

        var selectedDealerId = $("#selectDealer").find(":selected").val();
        console.log(selectedDealerId);
        if (selectedDealerId === '') {
            $('#selectDealer').css('border-color', '#dc3545');
            $('#selectDealer').addClass('is-invalid');
            $('.selectDealer').html('Proszę wybrać dealera');
            var errors = 1;
        } else {
            $('#selectDealer').css('border-color', '#D9D9D9');
        }
        var model = $('#input_model').val();
        var dealer = $('#input_dealer').val();
        var agree1 = $('#testdriveAgreeEmail').prop('checked');
        var agree2 = $('#testdriveAgreePhone').prop('checked');
        var agree3 = $('#accessoriesAgreeRegulations1').prop('checked');
        var agree4 = $('#accessoriesAgreeRegulations2').prop('checked');
        var agreeVal1 = 0;
        var agreeVal2 = 0;
        var agreeVal3 = 0;
        var agreeVal4 = 0;
        if (agree1) {
            agreeVal1 = 1;
        }
        if (agree2) {
            agreeVal2 = 1;
        }
        if (agree3) {
            agreeVal3 = 1;
        }
        if (agree4) {
            agreeVal4 = 1;
        }

        if (!agree3) {
            var errors = 1;
            $('.form-check-input#accessoriesAgreeRegulations1').addClass('is-invalid');
            $('.walid_register_agree_email').html('<p>To pole jest wymagane</p>').show();
        }

        // var agree = $('#formContactAgreeEmail').prop('checked');
        // if (!agree) {
        //     $('.form-check-input#formContactAgreeEmail').addClass('is-invalid');
        //     $('.invalid-feedback-agree-email').html('<p>To pole jest wymagane</p>').show();
        //     var errors = 1;
        // } else {
        //     $('.form-check-input#formContactAgreeEmail').removeClass('is-invalid');
        //     $('.invalid-feedback-agree-email').empty().hide();
        //     agree = 1;
        // }

        // var agree2 = $('#formContactAgreePhone').prop('checked');
        // if (!agree2) {
        //     $('.form-check-input#formContactAgreeEmail').addClass('is-invalid');
        //     $('.invalid-feedback-agree-regulations2').html('<p>To pole jest wymagane</p>').show();
        //     var errors = 1;
        // } else {
        //     $('.form-check-input#formContactAgreeEmail').removeClass('is-invalid');
        //     $('.invalid-feedback-agree-regulations2').empty().hide();
        //     agree2 = 1;
        // }

        /*var agree4 = $('#testdriveAgreeRegulations2').prop('checked');
        if (!agree4) {
            $('#testdriveAgreeRegulations2').addClass('is-invalid');
            $('.walid_register_agree_regulations2').html('<p>To pole jest wymagane</p>').show();
            var errors = 1;
        } else {
            $('#testdriveAgreeRegulations2').removeClass('is-invalid');
            $('.walid_register_agree_regulations2').empty().hide();
            agree4 = 1;
        }*/

        const ids = {
            1: 297,
            8: 297,
            9: 295,
            10: 300,
            11: 299,
            12: 304,
            13: 305,
            14: 303,
            15: 296,
            16: 302,
            17: 301,
            18: 322,
            19: 319,
            20: 308,
            21: 318,
            22: 317,
            23: 325,
            24: 340,
            25: 333,
            26: 359,
            27: 341,
            28: 415,
            29: 370,
            30: 371,
            32: 372,
            33: 375,
            34: 410,
            36: 414
        }

        console.log(errors);
        if (errors == 0) {

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                'event': 'formSubmit',
                'form_id': 'accessories_form',
                firstname: firstname,
                lastname: lastname,
                email: email,
                phone: phone,
                postal_code: postalCode,
                branch_id: ids[selectedDealerId],
                /*utm_source: utm_source,
                utm_medium: utm_medium,
                utm_campaign: utm_campaign,*/
                i_consent_to_the_processing_of_my_data: agreeVal4,
                newsletter: agreeVal3,
            });

            $('#testdrive_contact .btn-form').attr("disabled", "true");
            $.ajax({
                type: 'POST',
                url: '/akcesoria/zapytaj',
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    firstname: firstname,
                    lastname: lastname,
                    email: email,
                    phone: phone,
                    postal_code: postalCode,
                    dealer: selectedDealerId,
                    branch_id: selectedDealerId,
                    /*utm_source: utm_source,
                    utm_medium: utm_medium,
                    utm_campaign: utm_campaign,*/
                    contact_channel_email: (agreeVal1 ? 1 : 0),
                    contact_channel_sms: (agreeVal2 ? 1 : 0),
                    contact_channel_phone: (agreeVal3 ? 1 : 0),
                    i_consent_to_the_processing_of_my_data: (agreeVal4 ? 1 : 0),
                },
                success: function (result) {

                    console.log(result);
                    $('#testdrive_contact .btn-form').removeAttr("disabled");

                    if (result.success) {

                        $('#formSuccess').modal('show')
                        $("#accessories_modal").trigger("reset");
                        $('#accessoriesFirstname').val('');
                        $('#accessoriesLastname').val('');
                        $('#accessoriesEmail').val('');
                        $('#accessoriesPhone').val('');
                        $('#accessoriesPostalCode').val('');
                        $('#selectDealer').val('');
                        $('#testdriveAgreeEmail').prop('checked', false);
                        $('#testdriveAgreePhone').prop('checked', false);
                        $('#testdriveAgreeRegulations1').prop('checked', false);
                        $('#testdriveAgreeRegulations2').prop('checked', false);

                        $('#accessories_modal').modal('hide');

                    } else {
                        alert('Zapis nie powiódł się. Spróbuj ponownie');
                    }
                }
            });
        }
    });

    function IsEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    function validatePhone(txtPhone) {
        var regex = /^[0-9]+$/
        return regex.test(txtPhone);
    }

    function validatePostalCode(txtPhone) {
        var regex = /^[0-9]{2}-[0-9]{3}$/
        return regex.test(txtPhone);
    }


    $(".form-select").change(function () {
        if ($(this).val() !== " ") {
            $('.select_title').addClass('active');
        } else {
            // Pole nie jest zaznaczone
            $('.select_title').removeClass('active');
        }
    });
});
